'use strict';
var has = require('../internals/set-helpers').has;

// Perform ? RequireInternalSlot(M, [[SetData]])
module.exports = function (it) {
  has(it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-set.js
// module id = 109
// module chunks = 0